export enum ETabs {
  ADD = 'add',
  DISCARD = 'discard',
}
